<template>
  <div class="scrollableY">
      

        <div id="settsBar" class="settingsMenu settsOpen has-text-white" ref="bar">
            <div class="handCursor settsArrow"  @click="toggleOpen"><i :class="{'fa fa-chevron-left': menuOpen, 'fa fa-chevron-right' : !menuOpen, 'arrowAdj' : !menuOpen}"></i></div>
            
            <div class="top40">
                <div v-if="!$root.app.inApp && !hasUpgraded" class="settingsItem" :class="{selected: comp == 'landing'}" @click="loadItem('landing')">PLAN</div>
                <div class="settingsItem" :class="{selected: comp == 'account'}" @click="loadItem('account')">ACCOUNT</div>
                <div v-if="!$root.app.inApp && hasUpgraded" class="settingsItem" :class="{selected: comp == 'managesub'}" @click="loadItem('subscription')">SUBSCRIPTION<br ></div>
                <div v-if="!$root.app.inApp && hasUpgraded" class="settingsItem" :class="{selected: comp == 'pmtSrc'}" @click="loadItem('pmtSrc')">PAYMENT INFO<br ></div>
                <!-- <div class="settingsItem" :class="{selected: comp == 'delacc'}" @click="loadItem('delacc')">DELETE ACCOUNT</div> -->
                <div class="infoPagItemBotBorder"></div>
                <div class="settingsItem top30" :class="{selected: comp == 'about'}" @click="loadItem('about')" >ABOUT US</div>
                <div class="settingsItem" :class="{selected: comp == 'faq'}" @click="loadItem('faq')" >FAQ</div>
                <div class="settingsItem " :class="{selected: comp == 'help'}" @click="loadItem('help')" >HELP</div>
                <div class="settingsItem" :class="{selected: comp == 'contact'}" @click="loadItem('contact')" >CONTACT US</div>
                <div v-if="$root.app.inApp" class="top30">For more options please log in from a web browser</div>
            </div>
          </div >
            
     

       <div  class="settingsContent posRelative">
            <div ref="theContent" v-show="!staticPage" class="container top40 paddingInInfo">
                <div v-for="(item, i) in source" :key="i">
                    <component :is="item.comp" :params="item.params" :index="i"></component>
                </div>
            </div>

            <div v-if="staticPage" class="settingsContent posRelative"> 
                <component :is="comp" :id="id" ref="main"></component>
            </div>
       </div>
       <!-- <div id="spinner" class="top160 bottom40"></div> -->
       <footerdiv ></footerdiv>
  </div>

</template>

<script>

import { AZEventBus } from '../components/AZEventBus'
import titleSection from '../components/cms/titleSection.vue'
import subTitleSection from '../components/cms/subTitleSection.vue'
import threeColumns from '../components/cms/threeColumns.vue'
import fourColumns from '../components/cms/fourColumns.vue'
import paragraph from '../components/cms/paragraph.vue'
import imageAndText from '../components/cms/imageAndText.vue'
import divider1 from '../components/cms/divider1.vue'
import searchBundles from '../components/SearchPBundles.vue'
import threeAds from '../components/cms/threeAds.vue'
import Footerdiv from '../components/Footer.vue'
import bundleComplete from '../components/cms/bundleComplete.vue'
import contact from '../components/SettsContact.vue'
import faq from '../components/cms/cmsFaq.vue'
import terms from '../components/SettsTerms.vue'
import landing from '../components/SettsLanding.vue'
import privacy from '../components/SettsPrivacy.vue'
import help from '../components/SettsHelp.vue'
import account from '../components/SettsAcc.vue'
import delacc from '../components/SettsDelAcc.vue'
import managesub from '../views/ManageSub.vue'
import pmtSrc from '../views/PmtSrc.vue'


export default {
    components: {titleSection, subTitleSection, threeColumns, paragraph, imageAndText, divider1, fourColumns, threeAds, Footerdiv, bundleComplete, searchBundles, contact, faq, terms, privacy, account, help, delacc, managesub, pmtSrc, landing},
    props: ['section','id'],
    data: function(){
        return {
            inited: false,
            source: [],
            done: false,
            menuOpen: true,
            staticPage: true,
            comp: 'account',
            hasUpgraded: false
        }
    },

    mounted: function(){
        var self = this

        this.hasUpgraded = this.$root.app.userAttrs.hasUpgraded;

        function w(d){
            az.addRemSpinner(false, 'id', 'spinner')
      
            if(d == 'notFound') 
                self.$router.push('/p404')

            if(d.isLive){
                self.source = JSON.parse(d.source)
                self.done = true

            } else {
                self.$router.push('/p404')
            }
        }

        function n(){
            az.addRemSpinner(false, 'id', 'spinner')
        }


        function init(){

            self.$root.app.apiClient.get('auth/account/hasUpgraded', {}, (data) => {
                self.hasUpgraded = data.hasUpgraded;
            }, (e) => {
                console.log(e);
            })
            

            if(!self.$root.app.inApp){
                if((!self.section && !self.hasUpgraded) || self.section == 'landing'){
                    self.loadItem('landing', true)
                } else {
                    self.loadItem('account', true)
                }
            } else {
                if(!self.section || self.section == 'account'){
                    self.loadItem('account', true)
                } 
            }

          

         

            /* if(!self.staticPage){
                az.addRemSpinner(true, 'id', 'spinner')
                self.$root.app.apiClient.get('open/confirm/onepage/' + self.id, {}, w, n)
            }  */
           self.loadItem(self.section, true)
            
        }

        if(self.$root.app.doneFederating){
           init();
        }

        AZEventBus.$once('onFederate', msg => {
            init();
        });
        
    },

    methods: {
        toggleOpen: function(){
          if(this.menuOpen){
            this.$refs.bar.style.left = '-190px'
            this.$refs.theContent.style['padding-left'] = '30px'
            this.menuOpen = false
          } else {
            this.$refs.bar.style.left = '0px'
            this.menuOpen = true
          }
      },

      updUrl: function(){
        var self = this;
        var theId = ''
        if(this.comp == 'help' && this.id != 'help')
            theId += '/' +this.id
        history.replaceState(
            {},
            null,
            '/accsettings/' + this.comp + theId
        )
      },

      loadItem: function(id, firstLoad){
        var self = this;
        if(this.menuOpen && !firstLoad){
            this.toggleOpen()
        }
        if(id == 'about'){
            this.id = 'about' //process.env.VUE_APP_ROOT_ABOUT
            this.staticPage = false
            this.comp = 'about'
            this.updUrl()
        } else if(id == 'press'){
            this.id = 'newsroom' //process.env.VUE_APP_ROOT_NEWSROOM
            this.staticPage = false
            this.comp = 'press'
            this.updUrl()
        } else if(id == 'faq'){
            this.id = 'faq' //process.env.VUE_APP_ROOT_FAQ
            this.staticPage = false
            this.comp = 'faq'
            this.updUrl()
        } else if(id == 'help'){
            this.$route.params.id ? this.id = this.$route.params.id : this.id = 'help'
            this.staticPage = true
            this.comp = 'help'
            this.updUrl(this.id)
        } else if(id == 'contact'){
            this.staticPage = true
            this.comp = 'contact'
            this.updUrl()
        } else if(id == 'terms'){
            this.staticPage = true
            this.comp = 'terms'
            this.updUrl()
        } else if(id == 'privacy'){
            this.staticPage = true
            this.comp = 'privacy'
            this.updUrl()
        } else if(id == 'account'){
            this.staticPage = true
            this.comp = 'account'
            this.updUrl()
        } else if(id == 'delete'){
            this.staticPage = true
            this.comp = 'delete'
            this.updUrl()
        } else if(id == 'delacc'){
            this.staticPage = true
            this.comp = 'delacc'
            this.updUrl()
        } else if(id == 'subscription'){
            this.staticPage = true
            this.comp = 'managesub'
            this.updUrl()
        } else if(id == 'pmtSrc'){
            this.staticPage = true
            this.comp = 'pmtSrc'
            this.updUrl()
        } else if(id == 'landing'){
            this.staticPage = true
            this.comp = 'landing'
            this.updUrl()
        } 

     
        

        function w(d){
            az.addRemSpinner(false, 'id', 'spinner')
      
            if(d == 'notFound') 
                self.$router.push('/p404')

            if(d.isLive){
                self.source = JSON.parse(d.source)
                self.done = true

            } else {
                self.$router.push('/p404')
            }
        }

        function n(){
            az.addRemSpinner(false, 'id', 'spinner')
        }

        if(!this.staticPage){
            az.addRemSpinner(true, 'id', 'spinner')
            self.$root.app.apiClient.get('open/confirm/onepage/' + self.id, {}, w, n)
        }

      }
    }

}



</script>